import { render, staticRenderFns } from "./qs1-11.vue?vue&type=template&id=5c2a0cc8&scoped=true&"
import script from "./qs1-11.vue?vue&type=script&lang=js&"
export * from "./qs1-11.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2a0cc8",
  null
  
)

export default component.exports